import {Link, useParams, useNavigate} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, bytesToSize, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import VideoPlayer from '../components/video/video';
import AudioPlayer from '../components/video/audio';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
import AudioWaveform from '../components/video/waveform';
import Chatbox from '../components/messenger/chatbox';
import axios from 'axios';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import '../components/schedule/schedule.css';
import './css/publish.css';

class PortalServiceReplay extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {

			service: {
				status: false,
				id: this.props.service,
				name: '',
			},

      //servicekey: '',

			tab: 'overview',

			replay: {},
			chats: [],
			playlist: [],
			analytics: [],
			followers: [],
			publish: [],
			
			avatars: [],
			audio: [],
      
			genres: {
        show: false, // to show selection
        value: '', // searching
        fulllist: [], // full list of genres
        picker: {}, // selected genres
        picked: []
      },
			publishing: {},
			complete: false
		};
		this.getReplay = this.getReplay.bind(this);
		this.length = this.length.bind(this);
		this.setTab = this.setTab.bind(this);

		this.selectGenre = this.selectGenre.bind(this);
		this.removeGenre = this.removeGenre.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.submitEvent = this.submitEvent.bind(this);
  };

  async componentDidMount() {
		//document.title = "";

		//---- This i believe you do actaully to update on page changes!
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		EventEmitter.emit('/client', y);

		
		this.getReplay();
		
		this.uploadFiles = this.uploadFiles.bind(this);
		
	}

	componentWillUnmount() {
    
	}

	async getReplay() {
		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${value.worker[this.state.service.id]}/v3/service/replay/${this.props.id}`, params);
		consoleLog(x.data);
		setTitle(x.data?.replay?.showname);
		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		
		
		this.setState({
			service,
			replay: x.data.replay || {},
			chats: x.data.chats || [],
			playlist: x.data.playlist || [],
			analytics: x.data.analytics || [],
			followers: x.data.followers || [],
			publish: x.data.publish || [],
			avatars: x.data.avatars || [],
			audio: x.data.audio || [],
		});
		if( Object.values(this.state.publishing).length === 0 ) {
			let genres = this.state.genres;
			genres.fulllist = x.data.defaultgenres;
			genres.picked = x.data.replay.genres ? x.data.replay.genres : [];
			let publishing = {
				platform: null,
				avatar: null,
				audio: null,
				showname: x.data.replay.showname,
				description: x.data.replay.description,
				playlist: x.data.replay.playlist || [],
				genres: x.data.replay.genres
			};
			this.setState({publishing, genres});

		}
	}

	length(length) {
		length /= 60;
		let hours = Math.floor(length / 60);
		let minutes = Math.floor(length % 60);
  	return hours===0?`${minutes} mins`:`${hours} hrs ${minutes} mins`;
	}


	setTab(id) {
		this.setState({tab: id});
	}


	async uploadFiles(event) {
		const value = this.context;
		const params = new FormData();
		params.append('service', this.state.service.id);
		params.append('schedule', this.state.replay.schedule);
		const selectedFiles = event.target.files;
		for (let i = 0; i < selectedFiles.length; i++) {
			params.append('files',selectedFiles[i]);
		}
		await axios.post(`${value.worker[this.state.service.id]}/v3/service/replay/${this.props.id}/upload`, params, {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			withCredentials: true,
			/*onUploadProgress: (progressEvent) => {
				let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
				//this.setState({percent: percentCompleted});
			}*/
		});
		await this.getReplay();
		/*this.setState({percent: -1, failed: x.data.failed},()=>{
			this.gatherFiles();
		});*/
	}

	
	selectGenre(genre) {
    let genres = this.state.genres;
    genres.show = false;
    genres.value = '';
		for( let i in genres.picker ) if( genre === genres.picker[i] ) return;
		genres.picked.push(genre);
		this.setState({genres});
	}

	removeGenre(genre) {
		let genres = this.state.genres;
		for( let i in genres.picked ) if( genre === genres.picked[i] ) genres.picked.splice( i, 1 );
		this.setState({genres});
	}

	handleChange(event) {
		let {name, value} = event.target;
		let publishing = this.state.publishing;

		switch(name) {
			case 'platform':
				publishing.platform = value;
			break;
			case 'avatar':
				publishing.avatar = value;
			break;
			case 'audio':
				publishing.audio = value;
			break;
			case 'showname':
				publishing.showname = value;
			break;
			case 'description':
				publishing.description = value;
			break;
			case 'playlist':
			break;
			case 'genre':
				let genres = this.state.genres;
				genres.value = value;
				let _new = {};
				if( value.length >= 4 ) {
					genres.show = true;
					for( let i in this.state.genres.fulllist ) {
						for( let j in this.state.genres.fulllist[i] ) {
							let search = new RegExp(`(${value.replace(' ','|')})`,"gi");
							if( this.state.genres.fulllist[i][j].match(search) != null ) {
								if( !_new[i] ) _new[i] = [];
								_new[i].push(this.state.genres.fulllist[i][j]);
							}
						}
					}
				} else genres.show = false;
				genres.picker = _new;
				this.setState({genres});
			break;
			default: break;
		}
		this.setState({publishing});
	}

	async submitEvent(event) {
		if( event ) event.preventDefault();

		const value = this.context;
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('pid', this.state.replay.id);

		let publishing = this.state.publishing;
		publishing.genres = this.state.genres.picked;

		for( let i in publishing )
			if( publishing[i] ) {
				params.append(i, (i==='genres'||i==='playlist')?JSON.stringify(publishing[i]):publishing[i]);
			}
		const x = await putApi(`${value.worker[this.state.service.id]}/v3/service/replay/${this.props.id}/upload`, params);
		if( x.status === 200 ) {
			this.setState({complete: true});
		}
	}

  
	render() {
		const user = this.context;
		


		//---- Publish

		const publish = this.state.publish.map((e,i) => {
			return (
				<option key={i} value={e.id}>{e.platform}</option>
			)
		});

		const avatars = this.state.avatars.map((e,i) => {
			return (
				<div key={i} className="publish-avatar" onClick={()=>this.handleChange({target: { name: 'avatar', value: e}})}>
					<img src={`${user.worker[this.state.service.id]}${e}`} alt="avatars" />
					{this.state.publishing.avatar === e && <div className="publish-avatar-check"><FontAwesomeIcon icon="check" /></div>}
				</div>
			)
		});

		const audio = this.state.audio.map((e,i) => {
			let name = e.split('/').pop();
			return (
				<div key={i} className="publish-audio">
					<span className="publish-audio-name" onClick={()=>this.handleChange({target: { name: 'audio', value: e}})}>filename: {name}
						{this.state.publishing.audio === e && <div className="publish-audio-check"><FontAwesomeIcon icon="check" /></div>}
					</span><br />
					<audio controls >
  					<source src={`${user.worker[this.state.service.id]}${e}`} crossOrigin="use-credentials" />
						Your browser does not support the audio element.
					</audio>
					
				</div>
			)
		});

		const genrelist = Object.keys(this.state.genres.picker).map((e,i) => {
			return (
				<React.Fragment key={i}>
					<div><p>{e}</p></div>
					<div style={{display: 'flex', flexFlow: 'row wrap', marginLeft: -5}}>
						{(() => {
							return Object.keys(this.state.genres.picker[e]).map((f,j) => {
								return (
									<Button key={j} className="btn btn-sm btn-info my-1 me-2" onClick={()=>this.selectGenre(this.state.genres.picker[e][f])}>{this.state.genres.picker[e][f]}</Button>
								)
							})
						})()}
					</div>
					<div style={{clear: 'both', paddingBottom: 10}}></div>
				</React.Fragment>
			)
		});
		const genrepicked = this.state.genres.picked.map((e,i) => {
			return (
				<Button key={i} size="sm" className="btn btn-teal-gradient btn-wave waves-effect waves-light">{e}
					<OverlayTrigger placement="top" key="overlay-5" overlay={<Tooltip id="tooltip5">Remove Genre</Tooltip>}>
						<span className="badge ms-2 bg-white text-primary" onClick={()=>this.removeGenre(e)}><FontAwesomeIcon icon="xmark" /></span>
					</OverlayTrigger>
					
				</Button>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Replays</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
								<Col xs={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Video Replays</span>
													<p className="fs-13 text-muted mb-0">View your recordings and stream analytics.</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
                  </div>
                </Col>
              </Row>
							<Row className="gx-0">
								<Col xs={12}>
									<table className="table text-nowrap">
										<tbody>
											<tr>
												<td colSpan={6}>
													<Tabs
														defaultActiveKey="profile"
														id="justify-tab-example"
														className="mb-3"
														activeKey={this.state.tab}
														onSelect={(k) => this.setTab(k)}
														justify
													>
														<Tab eventKey="overview" title="Overview">
															<Row>
																<Col md={7}>
																	<p>
																		{this.state.replay.access === true ?`Video`:`Audio` }: {this.state.replay.showname}<br />
																		Duration: {this.length(this.state.replay.length)}<br />
																		Expires: {moment((this.state.replay.ctime+this.state.replay.remove)*1000).format("DD/MM/YYYY H:mm:ss")}
																		</p>
																	{this.state.replay.access === true ?
																		<VideoPlayer
																			id="video"
																			//service={this.state.service.id} //{this.state.select.address}
																			//select={this.state.select_temp.select}
																			//uid={this.state.stage.live?.uid}
																			theatre={()=>{}}
																			onError={()=>{}}
																			height={100}
																			url={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename}?d=${Math.floor(Date.now()/1000)}`}
																			controls={true}
																			muted={false}
																			autoPlay={false}
																		/>
																	:
																		<>
																			<img src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','png')}?d=${Math.floor(Date.now()/1000)}`} crossOrigin="use-credentials" width="100%" alt="Replay Avatar" />
																			<AudioPlayer src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','m4a')}?d=${Math.floor(Date.now()/1000)}`} />
																		</>
																	}
																</Col>
																<Col>
																	{//this.state.replay.chats &&
																		<Chatbox
																			service={this.state.service.id}
																			category={'replay'}
																			type={'full'}
																			chats={this.state.replay.chats}
																		/>
																	}
																</Col>
																<Col xs={12}><hr /></Col>
																<Col>
																	<AudioWaveform
																		url={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','dat')}?d=${Math.floor(Date.now()/1000)}`}
																		barWidth={2}
																		height={50}
																		color="#3E5151"
																		progressGradientColors={[[0, "#07E6A5"], [1, "#00A4FC"]]}
																	/>
																</Col>
																<Col md={3}>
																	<div className="d-grid gap-2">
																		{this.state.replay.access === true &&
																			<a href={this.state.replay.video_mp4===0?`#`:`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.showname.replaceAll(' ','')}.mp4?d=${Math.floor(Date.now()/1000)}`}>
																				<Button size="sm" style={{width: 200}} disabled={this.state.replay.video_mp4===0?true:false}><FontAwesomeIcon icon="download" />  Video MP4 ({this.state.replay.video_mp4===0?'Waiting':bytesToSize(this.state.replay.video_mp4)})</Button>
																			</a>
																		}
																		<a href={this.state.replay.audio_mp3===0?`#`:`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','mp3')}?d=${Math.floor(Date.now()/1000)}`}>
																			<Button size="sm" style={{width: 200}} disabled={this.state.replay.audio_mp3===0?true:false}><FontAwesomeIcon icon="download" /> Audio MP3 ({this.state.replay.audio_mp3===0?'Waiting':bytesToSize(this.state.replay.audio_mp3)})</Button>
																		</a>
																		<a href={this.state.replay.audio_m4a===0?`#`:`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','m4a')}?d=${Math.floor(Date.now()/1000)}`}>
																			<Button size="sm" style={{width: 200}} disabled={this.state.replay.audio_m4a===0?true:false}><FontAwesomeIcon icon="download" /> Audio M4A ({this.state.replay.audio_m4a===0?'Waiting':bytesToSize(this.state.replay.audio_m4a)})</Button>
																		</a>
																	</div>
																</Col>
															</Row>
														</Tab>
														<Tab eventKey="playlist" title="Playlist">
															TrackID - Playlist
														</Tab>
														<Tab eventKey="analytics" title="Analytics">
															Analytics
														</Tab>
														<Tab eventKey="folloers" title="Followers">
															Folowers
														</Tab>
														{this.state.replay.access === true && this.state.complete === false && Object.values(this.state.publishing).length > 0 &&
															<Tab eventKey="publish" title="Publish">
																
																<div className="form-group row pt-1 pb-0 mb-1">
																	<div className="d-flex">
																		<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																			<strong>Platform</strong>
																		</label>
																	
																		<div className="col-md-6 ">
																			<Form.Select aria-label="Default select example" name="platform" onChange={this.handleChange}>
																				<option vlaue={0}>Please select publishing platform</option>
																				{publish}
																			</Form.Select>
																		</div>
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<div className="d-flex">
																		<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																			<strong>Publish Avatar</strong>
																		</label>
																	
																		<div className="col-md-6">
																			<div className="d-flex">
																				<div className="publish-avatar" onClick={()=>this.handleChange({target: { name: 'avatar', value: null}})}>
																					<img src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','png')}?d=${Math.floor(Date.now()/1000)}`} path={`radio/${this.state.service.id}/publish/${this.state.replay.schedule}/`} crossOrigin="use-credentials" alt="avatars" />
																					{this.state.publishing.avatar === null && <div className="publish-avatar-check"><FontAwesomeIcon icon="check" style={{fontWeight: 800, fontSize: 16}} /></div>}
																				</div>
																				{avatars}
																			</div>
																			{/*<UploadFile src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','png')}?d=${Math.floor(Date.now()/1000)}`} path={`radio/${this.state.service.id}/publish/${this.state.replay.schedule}/`} onChange={this.changeAvatar}/>*/}
																			<br />
																			<Button size="sm" onClick={()=>document.getElementById('upload').click()}>Upload</Button>
																		</div>
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<div className="d-flex">
																		<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																			<strong>Publish Audio Track</strong>
																		</label>
																	
																		<div className="col-md-6">

																			<div className="publish-audio">
																				<span className="publish-audio-name" onClick={()=>this.handleChange({target: { name: 'audio', value: null}})}>filename: {this.state.replay.filename.replace('mp4','m4a')}
																					{this.state.publishing.audio === null && <div className="publish-audio-check"><FontAwesomeIcon icon="check" /></div>}
																				</span><br />
																				<audio controls crossOrigin="use-credentials" >
																					<source src={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','m4a')}?d=${Math.floor(Date.now()/1000)}`} path={`radio/${this.state.service.id}/publish/${this.state.replay.schedule}/`} />
																					Your browser does not support the audio element.
																				</audio>
																			</div>
																			{audio}
																			
																			{/*<UploadFile src={user.user.user.avatar.replace('/images/','')} path={`profile/${user.user.user.id}/`} onChange={this.changeAvatar}/>*/}

																			{/*<AudioWaveform
																				url={`${user.worker[this.state.service.id]}/v3/service/replay/${this.state.service.id}/${this.state.replay.schedule}/${this.state.replay.filename.replace('mp4','dat')}?d=${Math.floor(Date.now()/1000)}`}
																				barWidth={2}
																				height={50}
																				color="#3E5151"
																				progressGradientColors={[[0, "#07E6A5"], [1, "#00A4FC"]]}
																			/>*/}
																			<br />
																			<Button size="sm">Upload</Button>
																		</div>
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<div className="d-flex">
																		<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																			<strong>Publish Showname</strong>
																		</label>
																	
																		<div className="col-md-6">
																			<Form.Control type="showname" value={this.state.publishing.showname} name="showname" onChange={this.handleChange} />
																		</div>
																	</div>
																</div>

																<div className="form-group row pt-1 pb-0 mb-1">
																	<div className="d-flex">
																		<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																			<strong>Publish Description</strong>
																		</label>
																	
																		<div className="col-md-6">
																			<Form.Control as="textarea" rows={8} value={this.state.publishing.description} name="description" onChange={this.handleChange}>
																				{this.state.replay.description}
																			</Form.Control>
																		</div>
																	</div>
																</div>

																{this.state.playlist.length > 0 &&
																	<div className="form-group row pt-1 pb-0 mb-1">
																		<div className="d-flex">
																			<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																				<strong>Publish Playlist</strong>
																			</label>
																		
																			<div className="col-md-6">
																				<Form.Control type="playlist" />
																			</div>
																		</div>
																	</div>
																}

																<div className="form-group row pt-1 pb-0 mb-1">
																	<div className="d-flex">
																		<label className="col-sm-4 col-form-label col-form-label-sm ps-2">
																			<strong>Publish Genres</strong>
																		</label>
																	
																		<div className="col-md-6" style={{position: 'relative'}}>
																			<Form.Control type="text" name="genre" id="genre" value={this.state.genres.value} onChange={this.handleChange} className="form-control-sm" placeholder="Search Genres">
																			</Form.Control>
																			{this.state.genres.show === true &&
																				<div className="card card-body p-1" style={{position: 'absolute', top: 33, width: '96%', fontSize: 14, maxHeight: 245, overflowY: 'scroll', zIndex:5}}>
																					<div className="blockquote custom-blockquote info mb-0" style={{padding: 10}}>
																						{genrelist}
																					</div>
																				</div>
																			}
																			<div className="genrepick-box">
																				{genrepicked}
																			</div>
																		</div>
																	</div>
																</div>

																<Button size="sm" onClick={(e)=>this.submitEvent(e)}>Publish</Button>

																<div style={{height: 200}} />

															</Tab>
														}
														{this.state.complete === true &&
															<Tab eventKey="publish" title="Publish">
																<div className="text-center" style={{position: 'relative'}}>
																	<div className="publish-complete">
																		<span>
																			<FontAwesomeIcon icon="check" size="2xl" />
																		</span>
																	</div>
																	Publish complete and will be available in the next few minutes.
																</div>
															</Tab>
														}
													</Tabs>
												</td>
												<td style={{verticalAlign: 'top'}}>
													<Button size="sm" onClick={()=>this.props.navigate(`/${this.state.service.id}/replays`)}>
														<FontAwesomeIcon icon="times" />
													</Button>
												</td>
											</tr>
										</tbody>
									</table>
								</Col>
							</Row>
            </div>
					</div>
				}
				<input id="upload" type="file" onChange={this.uploadFiles} style={{display: 'none'}} />
			</>
		);
	}
}

const Replays = props => {
  const { service, id } = useParams();
	const navigate = useNavigate();
  return <PortalServiceReplay service={service} id={id} navigate={navigate} {...props} />
}
export default Replays;